import { render, staticRenderFns } from "./gopay.vue?vue&type=template&id=0c1d2436&scoped=true"
import script from "./gopay.vue?vue&type=script&lang=js"
export * from "./gopay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d2436",
  null
  
)

export default component.exports